import { Box, Grid, Typography } from "@mui/material";
import { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { SpinnerButton } from "../../../../../../common/components/functional/spinnerButton/SpinnerButton";
import { ActionButton } from "../../../../../talentProfile/styles";
import { Clear as DeleteIcon } from "@mui/icons-material";
import { useFormContext } from "react-hook-form";
import isEmpty from "../../../../../../common/helpers/isEmpty";
import { useParams } from "react-router-dom";
import {
  WORK_AGREEMENT_ACCEPTED,
  WORK_AGREEMENT_DECLINED,
} from "../../../../constants";
import { FormKeys, WorkOfferType } from "../helpers";
import { useAppSelector } from "../../../../../../app/hooks";
import { selectReplacementWorkAgreementData } from "../../../../../../app/appSlice";

interface Props {
  onCancel: MouseEventHandler<HTMLButtonElement>;
  onAccept: MouseEventHandler<HTMLButtonElement>;
  isLoading: boolean;
  type: WorkOfferType;
  hasSystemGeneratedDocument: boolean;
}

export const FormActions = ({
  onCancel,
  onAccept,
  isLoading,
  type,
  hasSystemGeneratedDocument,
}: Props) => {
  const { t } = useTranslation("order");
  const {
    formState: { errors, isSubmitted },
    getValues,
    watch,
  } = useFormContext();
  const { workAgreementId } = useParams();
  const replacementWorkAgreementData = useAppSelector(
    selectReplacementWorkAgreementData,
  );

  const workAgreementDocumentId = watch(FormKeys.WorkAgreementDocumentId);
  const status = getValues("status");
  const isReadOnly: boolean =
    status === WORK_AGREEMENT_ACCEPTED || status === WORK_AGREEMENT_DECLINED;

  const cancelText = t("order:cancelWorkOffer");
  const normalAcceptText = workAgreementId
    ? t("order:updateWorkOffer")
    : type === WorkOfferType.New
      ? replacementWorkAgreementData
        ? t("order:sendReplacementWorkAgreement")
        : t("order:sendWorkOffer")
      : t("order:createWorkAssignment");
  const acceptText =
    workAgreementDocumentId && !hasSystemGeneratedDocument
      ? t("order:createAssignment")
      : normalAcceptText;

  const acceptDisabled = !isEmpty(errors) || isReadOnly;
  const showInvalidFormText = isSubmitted && !isEmpty(errors);

  return (
    <Grid
      container
      item
      xs={12}
      justifyContent="space-between"
      alignItems="center"
      paddingTop="0.5rem"
    >
      {workAgreementId ? (
        <Box>
          <ActionButton
            variant="outlined"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={onCancel}
            disabled={isReadOnly}
          >
            {cancelText}
          </ActionButton>
        </Box>
      ) : (
        <Box />
      )}
      <Box>
        <SpinnerButton
          color="primary"
          variant="contained"
          onClick={onAccept}
          label={acceptText}
          isLoading={isLoading}
          disabled={acceptDisabled}
          sx={{
            height: "36px",
            borderRadius: "20px",
          }}
        />
        {showInvalidFormText && (
          <Typography color="error">{t("common:checkFormValues")}</Typography>
        )}
      </Box>
    </Grid>
  );
};
